export enum IntermediateScreen {
  FirstStepIsDone = 'FirstStepIsDone',
  AEBenefits = 'AEBenefits',
  LongTimeNoSee = 'LongTimeNoSee',
  VideoInterviewFinished = 'VideoInterviewFinished',
  TestTaskSent = 'TestTaskSent',
  TestTaskDone = 'TestTaskDone',
}
